<template>
<div>
    <section class="medform_topbar">
        <div class="medform_topwrap">
            <div class="medform_topdiv">
                <div class="medform-logo-div"><img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/_Rx-Pros-Logo-01-p-500.png 500w, @/assets/images/_Rx-Pros-Logo-01-p-800.png 800w, @/assets/images/_Rx-Pros-Logo-01-p-1080.png 1080w, @/assets/images/_Rx-Pros-Logo-01.png 2083w" alt="" src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" class="image-672">
                    <div class="top_rating-div">
                        <div class="text-block-1667">Excellent</div><img loading="lazy" src="@/assets/images/icon_stars-black.svg" alt="" class="image-671">
                    </div>
                </div>
                <div class="medform_progressdiv">
                    <div class="progress_circle" :class="{ reached: currentStep >= 1, current: currentStep >= 1 && currentStep < 8 }"></div>
                    <div class="progress_text" :class="{ reached: currentStep >= 1, current: currentStep >= 1 && currentStep < 8 }">Start</div>
                    <div class="progress_divider"></div>
                    <div class="progress_circle" :class="{ reached: currentStep >= 8, current: currentStep >= 8 && currentStep < 15 }"></div>
                    <div class="progress_text" :class="{ reached: currentStep >= 8, current: currentStep >= 8 && currentStep < 15 }">Preliminary</div>
                    <div class="progress_divider"></div>
                    <div class="progress_circle" :class="{ reached: currentStep >= 15, current: currentStep >= 15 && currentStep < 25 }"></div>
                    <div class="progress_text" :class="{ reached: currentStep >= 15, current: currentStep >= 15 && currentStep < 25 }">Health</div>
                    <div class="progress_divider"></div>
                    <div class="progress_circle" :class="{ reached: currentStep >= 25, current: currentStep >= 25 && currentStep < 35 }"></div>
                    <div class="progress_text" :class="{ reached: currentStep >= 25, current: currentStep >= 25 && currentStep < 35 }">Details</div>
                    <div class="progress_divider"></div>
                    <div class="progress_circle" :class="{ reached: currentStep >= 35, current: currentStep >= 35 }"></div>
                    <div class="progress_text" :class="{ reached: currentStep >= 35, current: currentStep >= 35 }">Eligibility</div>
                </div>
            </div>
            <a href="#" class="form-back w-inline-block" @click.prevent="previousStep" v-show="currentStep > 1"><img loading="lazy" src="@/assets/images/icon_arrowback.svg" alt=""></a>
        </div>
    </section>
    <div class="medform_questions">
        <div class="medq_wrap">
            <div class="medq_maindiv">
                <div class="medform_question" v-show="currentStep === 1"><img sizes="(max-width: 1456px) 100vw, 1456px" srcset="@/assets/images/MEdForm_Headerimg3.png 500w, @/assets/images/MEdForm_Headerimg3.png 800w, @/assets/images/MEdForm_Headerimg3.png 1080w, @/assets/images/MEdForm_Headerimg3.png 1456w" alt="" src="@/assets/images/MEdForm_Headerimg3.png" loading="lazy" class="image-673">
                    <div class="medq_header-div">
                        <h1 class="medform_header">Reach your goal weight fast <span class="medq_headerspan">without restrictive diets and exercise.</span> </h1>
                        <div class="text-block-1668">Let&#x27;s calculate your BMI to make sure you&#x27;re a good candidate for medical weight loss.</div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a5a5">
                            <div class="medform_questionsdiv">
                                <div class="medform_questiontext">What is your height and weight?</div>
                            </div>
                            <div class="choice_flex">
                                <div class="choice_half-div"><label for="Feet" class="medform_field-label">Feet</label><select id="Feet" name="Feet" data-name="Feet" class="select-field-12 w-select" v-model="people.height.foot">
                                        <option value="">Select one...</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                    </select>
                                    <div v-if="formErrors.height" class="error-message">{{ formErrors.height }}</div>
                                </div>
                                <div class="choice_half-div"><label for="Inches" class="medform_field-label">Inches</label><select id="Inches" name="Inches" data-name="Inches" class="select-field-12 w-select" v-model="people.height.inches">
                                        <option value="">Select one...</option>
                                        <option value="0">0</option>
                                        <option value="1">1</option>
                                        <option value="2">2</option>
                                        <option value="3">3</option>
                                        <option value="4">4</option>
                                        <option value="5">5</option>
                                        <option value="6">6</option>
                                        <option value="7">7</option>
                                        <option value="8">8</option>
                                        <option value="9">9</option>
                                        <option value="10">10</option>
                                        <option value="11">11</option>
                                    </select></div>
                            </div><label for="weight" class="medform_field-label">Weight (in lbs)</label><input class="text-field-67 w-input" maxlength="256" name="weight" data-name="Weight" placeholder="180" type="number" id="weight" pattern="[0-9]*" v-model="people.weight">
                            <div v-if="formErrors.weight" class="error-message">{{ formErrors.weight }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 2">
                    <div class="medq_header-div">
                        <div class="medq-subs"><strong>Perfect!</strong> With a BMI of {{ people.bmi }}, we can continue.</div>
                        <h1 class="medform_header">We&#x27;re in this together. <span class="medq_headerspan">Your goal is our goal.</span></h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a5c7">
                            <div class="medform_questionsdiv">
                                <div class="medform_questiontext">What is your goal weight? </div>
                            </div><label for="desired-weight" class="medform_field-label">Weight (in lbs)</label><input class="text-field-67 w-input" maxlength="256" name="desired-weight" data-name="Desired Weight" placeholder="180" type="number" id="desired-weight" pattern="[0-9]*" v-model="people.desired_weight">
                            <div v-if="formErrors.desired_weight" class="error-message">{{ formErrors.desired_weight }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 3">
                    <div class="medq_header-div">
                        <h1 class="medform_header">Medication can be tailored to <span class="medq_headerspan">your unique needs</span>, so let&#x27;s get to know you a little better.</h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a5dd">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Are you male or female? </div>
                                <div class="medq_question-subs">This helps us understand your body complexity and hormones so we can assess you better.</div>
                            </div>
                            <div v-if="formErrors.gender" class="error-message">{{ formErrors.gender }}</div>
                            <div class="div-block-2225">
                                <div class="div-block-2226" @click="selectOption('gender', 'male')" :class="{ 'selected': people.gender === 'male' }">
                                    <div><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/67470ac4af52bf7a818cc2d0_Male.svg" alt="" class="gender-img">
                                        <div class="text-block-1673">Male</div>
                                    </div>
                                </div>
                                <div class="div-block-2226" @click="selectOption('gender', 'female')" :class="{ 'selected': people.gender === 'female' }">
                                    <div><img loading="lazy" src="https://uploads-ssl.webflow.com/668d55c8f0b55e9fc41fd2b8/668d8197d38318417c44d9c4_Female.svg" alt="" class="gender-img">
                                        <div class="text-block-1673">Female</div>
                                    </div>
                                </div>
                            </div>
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">What is your age range? </div>
                            </div><select id="Age-Range" name="Age-Range" data-name="Age Range" class="select-field-12 age w-select" v-model="people.age_range">
                                <option value="">please select your age range...</option>
                                <option value="18-28">18-28</option>
                                <option value="29-39">29-39</option>
                                <option value="40-50">40-50</option>
                                <option value="51-61">51-61</option>
                                <option value="62+">62+</option>
                            </select>
                            <div v-if="formErrors.age_range" class="error-message">{{ formErrors.age_range }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 4 && people.gender === 'male'">
                    <div class="medq_header-div">
                        <h1 class="medform_header">Men experience <span class="medq_headerspan">unique effects</span> from weight gain.</h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Do you experience any of the following?</div>
                            </div>
                            <div class="multilinkdiv">
                                <div class="medq_linksdiv">
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('low_libido') }" @click.stop.prevent="toggleMedicalCondition('low_libido')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed305d92185c15d6b5225a_icon_%20Libido.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Low Libido or Erectile Dysfunction</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('hair_loss') }" @click.stop.prevent="toggleMedicalCondition('hair_loss')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed1aed8b62b6bc6574ad9b_icon_%20Hair%20Loss.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Hair Loss</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('skin_issues') }" @click.stop.prevent="toggleMedicalCondition('skin_issues')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed305b00e6dfa5a4f5f81e_icon_%20Skin.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Skin Issues<br><span class="text-span-408">Dry Skin, Acne, Etc</span></span>
                                    </label>
                                </div>
                                <div class="medq_linksdiv minus-third">
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('cognition_issues') }" @click.stop.prevent="toggleMedicalCondition('cognition_issues')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed2178ca668ed07feaac9a_icon_%20Brain.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Cognition Issues<br><span class="text-span-408">Brain Fog, Trouble Focusing, Memory Loss</span></span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('none_of_these') }" @click.stop.prevent="toggleMedicalCondition('none_of_these')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/6704b9c2fe63bd23cc0c22ff_icon_Close.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">None of these</span>
                                    </label>
                                </div>
                            </div>
                            <div v-if="formErrors.medical_conditions" class="error-message">{{ formErrors.medical_conditions }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 5 && people.gender === 'female'">
                    <div class="medq_header-div">
                        <h1 class="medform_header">Safety, first.</h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a633">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Do any of these apply to you?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('pregnancy_status', 'pregnant')" >
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.pregnancy_status === 'pregnant' }">
                                        <img v-if="people.pregnancy_status === 'pregnant'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-pregnant" id="checkbox-pregnant" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.pregnancy_status === 'pregnant'"><span class="medq_checkbox-text w-form-label" for="checkbox-pregnant">Currently or possibly pregnant, or actively trying to become pregnant<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('pregnancy_status', 'breastfeeding')" >
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.pregnancy_status === 'breastfeeding' }">
                                        <img v-if="people.pregnancy_status === 'breastfeeding'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-breastfeeding" id="checkbox-breastfeeding" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.pregnancy_status === 'breastfeeding'"><span class="medq_checkbox-text w-form-label" for="checkbox-breastfeeding">Breastfeeding or bottle-feeding with breastmilk<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('pregnancy_status', 'postpartum')" >
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.pregnancy_status === 'postpartum' }">
                                        <img v-if="people.pregnancy_status === 'postpartum'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-postpartum" id="checkbox-postpartum" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.pregnancy_status === 'postpartum'"><span class="medq_checkbox-text w-form-label" for="checkbox-postpartum">Have given birth to a child within the last 6 months<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('pregnancy_status', 'none')" >
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.pregnancy_status === 'none' }">
                                        <img v-if="people.pregnancy_status === 'none'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-none-preg" id="checkbox-none-preg" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.pregnancy_status === 'none'"><span class="medq_checkbox-text w-form-label" for="checkbox-none-preg">None of the above</span>
                                </label>
                            </div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 6 && people.gender === 'female'">
                    <div class="medq_header-div">
                        <h1 class="medform_header">Women experience <span class="medq_headerspan">unique effects</span> from weight gain.</h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Do you experience any of the following?</div>
                            </div>
                            <div class="multilinkdiv">
                                <div class="medq_linksdiv">
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('low_libido') }" @click.stop.prevent="toggleMedicalCondition('low_libido')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed305d92185c15d6b5225a_icon_%20Libido.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Low Libido </span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('hair_loss') }" @click.stop.prevent="toggleMedicalCondition('hair_loss')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed1aed8b62b6bc6574ad9b_icon_%20Hair%20Loss.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Hair Loss</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('skin_issues') }" @click.stop.prevent="toggleMedicalCondition('skin_issues')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed305b00e6dfa5a4f5f81e_icon_%20Skin.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Skin Issues<br><span class="text-span-408">Dry Skin, Acne, Etc</span></span>
                                    </label>
                                </div>
                                <div class="medq_linksdiv minus-third">
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('cognition_issues') }" @click.stop.prevent="toggleMedicalCondition('cognition_issues')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/66ed2178ca668ed07feaac9a_icon_%20Brain.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Cognition Issues<br><span class="text-span-408">Brain Fog, Trouble Focusing, Memory Loss</span></span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" :class="{ 'selected': hasMedicalCondition('none_of_these') }" @click.stop.prevent="toggleMedicalCondition('none_of_these')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/6704b9c2fe63bd23cc0c22ff_icon_Close.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">None of these</span>
                                    </label>
                                </div>
                            </div>
                            <div v-if="formErrors.medical_conditions" class="error-message">{{ formErrors.medical_conditions }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 7">
                    <div class="medq_header-div">
                        <h1 class="medform_header">We can help with all of these, but choose the <span class="medq_headerspan">most important for you.</span></h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a68e">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Which of these is your priority? </div>
                            </div>
                            <div class="multilinkdiv">
                                <div class="medq_linksdiv">
                                    <label class="w-checkbox checkbox-field-medform thirds" @click.stop.prevent="selectAndAdvance('priority', 'lose_weight')" :class="{ 'selected': people.priority === 'lose_weight' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.priority === 'lose_weight'"><img loading="lazy" src="@/assets/images/icon_loseScale.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Lose Weight</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" @click.stop.prevent="selectAndAdvance('priority', 'gain_muscle')" :class="{ 'selected': people.priority === 'gain_muscle' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.priority === 'gain_muscle'"><img loading="lazy" src="@/assets/images/icon_muscle.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Gain Muscle</span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" @click.stop.prevent="selectAndAdvance('priority', 'maintain_body')" :class="{ 'selected': people.priority === 'maintain_body' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.priority === 'maintain_body'"><img loading="lazy" src="@/assets/images/icon_ok.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Maintain My<br>Current Body</span>
                                    </label>
                                </div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 8">
                    <div class="medq_header-div">
                        <h1 class="medform_header">It feels like magic, but it&#x27;s<br>‍<span class="medq_headerspan">metabolic science.</span></h1>
                    </div><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/Graph1_RxPro-01.png 500w, @/assets/images/Graph1_RxPro-01.png 800w, @/assets/images/Graph1_RxPro-01.png 1000w" alt="" src="@/assets/images/Graph1_RxPro-01.png" loading="lazy" class="image-678">
                    <div class="form-subs-div">
                        <div class="medq-subs">On average, RxPros patients <strong>lose over 20% of their body weight.<br><br></strong>GLP-1 medications are<strong> extremely effective</strong> - offering you a strong path toward your 130 pound goal weight.<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a7b2"><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 9">
                    <div class="medq_header-div center">
                        <h1 class="medform_header smaller">&quot;It really does work. Took about 6 weeks to feel it, but once it kicked in, <span class="text-span-409">I dropped 20 pounds of fat</span> and haven&#x27;t looked back. Thank you RxPros!&quot;</h1>
                    </div>
                    <div class="form_b-a_div">
                        <div class="form-b-a">
                            <div class="b-a-form-img"><img loading="lazy" src="@/assets/images/ba_1b_1ba_1b.webp" alt="" class="image-675"><img loading="lazy" src="@/assets/images/ba_1a_1ba_1a.webp" alt="" class="image-676"></div>
                        </div>
                    </div>
                    <div class="form-subs-div">
                        <div class="medq-subs centered">Nika <em>took control</em> and <strong>doubled</strong> her confidence in only 16 months.<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a7d1"><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 10">
                    <div class="medq_header-div center">
                        <h1 class="medform_header">How will GLP-1 <span class="medq_headerspan"><em>work for you?</em><br></span></h1>
                    </div>
                    <div class="form_imgdiv"><img sizes="(max-width: 1000px) 100vw, 1000px" srcset="@/assets/images/Graph2_RxPro-01.png 500w, @/assets/images/Graph2_RxPro-01.png 800w, @/assets/images/Graph2_RxPro-01.png 1000w" alt="" src="@/assets/images/Graph2_RxPro-01.png" loading="lazy" class="image-678"></div>
                    <div class="form-subs-div">
                        <div class="medq-subs"><strong>- Week 1- 4 :</strong> Your body gets acclimated to GLP-1 medication<br><strong>- Week 4-8</strong> : Weight loss is increasing more and more<br>- Week 9 + : Your body has become a <strong>fat burning machine<br><br></strong>We identify the root causes of your metabolic issues, so you get a <strong>long-term solution</strong>, not just another quick fix.<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a7f4"><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 11">
                    <div class="medq_header-div">
                        <h1 class="medform_header">Improving your life requires <span class="medq_headerspan">motivation.</span></h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a803">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">What is your <strong>primary reason</strong> for taking weight loss seriously?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('primary_reason', 'live_longer')" >
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.primary_reason === 'live_longer' }">
                                        <img v-if="people.primary_reason === 'live_longer'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.primary_reason === 'live_longer'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">I want to live longer<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('primary_reason', 'feel_look_better')" >
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.primary_reason === 'feel_look_better' }">
                                        <img v-if="people.primary_reason === 'feel_look_better'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.primary_reason === 'feel_look_better'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">I want to feel and look better<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('primary_reason', 'reduce_health_issues')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.primary_reason === 'reduce_health_issues' }">
                                        <img v-if="people.primary_reason === 'reduce_health_issues'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.primary_reason === 'reduce_health_issues'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">I want to reduce current health issues<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('primary_reason', 'all_of_these')" >
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.primary_reason === 'all_of_these' }">
                                        <img v-if="people.primary_reason === 'all_of_these'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.primary_reason === 'all_of_these'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">All of these</span>
                                </label>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 12">
                    <div class="medq_header-div">
                        <h1 class="medform_header">With medication, you&#x27;ll lose 2.7 to 3.6 pounds <span class="medq_headerspan">per week.</span></h1>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-subs-div _20-pad">
                        <div class="medq-subs no-pad">It will take about {{ weeksToLoseWeight }} weeks to reach your goal weight of {{people.desired_weight}}.<br></div>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a832">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">How is that pace for you?</div>
                            </div>
                            <div class="multilinkdiv">
                                <div class="medq_linksdiv"><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('weight_loss_pace', 'works_for_me')" :class="{ 'selected': people.weight_loss_pace === 'works_for_me' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.weight_loss_pace === 'works_for_me' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_loss_pace === 'works_for_me'"><img loading="lazy" src="@/assets/images/icon_check_blue.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">That works for me</span>
                                    </label><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('weight_loss_pace', 'want_faster')" :class="{ 'selected': people.weight_loss_pace === 'want_faster' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.weight_loss_pace === 'want_faster' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_loss_pace === 'want_faster'"><img loading="lazy" src="@/assets/images/icon_active.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">I want it faster</span>
                                    </label><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('weight_loss_pace', 'too_fast')" :class="{ 'selected': people.weight_loss_pace === 'too_fast' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.weight_loss_pace === 'too_fast' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_loss_pace === 'too_fast'"><img loading="lazy" src="@/assets/images/icon_hourglass.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">That&#x27;s too fast</span>
                                    </label></div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 13">
                    <div class="medq_header-div small-pad">
                        <h1 class="medform_header">Perfect!</h1>
                        <h1 class="medform_header smaller">Losing {{(people.weight - people.desired_weight).toFixed(0)}}lbs is easier than you think - and it <span class="text-span-409">doesn't involve restrictive diets.</span></h1>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-subs-div _20-pad">
                        <div class="medq-subs no-pad">Now, let's<strong> analyze your metabolism</strong> and discover how well your body processes macronutrients.<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a85f"><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 14">
                    <div class="medq_header-div small-pad">
                        <h1 class="medform_header">Not a problem, <span class="medq_headerspan">we can move faster.</span></h1>
                        <h1 class="medform_header smaller">It will take some work, but with GLP-1 medication, your goal to lose {{(people.weight - people.desired_weight).toFixed(0)}}lbs can be achieved in about {{ fastWeeksToGoal }} weeks - and it <span class="text-span-409">doesn't involve restrictive diets.</span></h1>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-subs-div _20-pad">
                        <div class="medq-subs no-pad">Now, let's<strong> analyze your metabolism</strong> and discover how well your body processes macronutrients.<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a87a">
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 15">
                    <div class="medq_header-div small-pad">
                        <h1 class="medform_header">We&#x27;ll move at <span class="medq_headerspan">your pace.</span><br></h1>
                        <h1 class="medform_header smaller">With GLP-1 medication, your goal to lose {{(people.weight - people.desired_weight).toFixed(0)}}lbs is easier than you think - and it <span class="text-span-409">doesn't involve restrictive diets.</span></h1>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-subs-div _20-pad">
                        <div class="medq-subs no-pad">Now, let's<strong> analyze your metabolism</strong> and discover how well your body processes macronutrients.<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a896"><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 16">
                    <div class="medq_header-div">
                        <h1 class="medform_header">How you sleep tells us a lot about your <span class="medq_headerspan">cortisol</span> and <span class="medq_headerspan">efficiency.</span> </h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a8a9">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">How is your sleep, overall?</div>
                            </div>
                            <div class="multilinkdiv">
                                <div class="medq_linksdiv"><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('sleep_quality', 'pretty_good')" :class="{ 'selected': people.sleep_quality === 'pretty_good' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.sleep_quality === 'pretty_good' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.sleep_quality === 'pretty_good'"><img loading="lazy" src="@/assets/images/icon_sleep.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Pretty Good</span>
                                    </label><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('sleep_quality', 'restless')" :class="{ 'selected': people.sleep_quality === 'restless' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.sleep_quality === 'restless' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.sleep_quality === 'restless'"><img loading="lazy" src="@/assets/images/icon_sad.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">A bit restless</span>
                                    </label><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('sleep_quality', 'poor')" :class="{ 'selected': people.sleep_quality === 'poor' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.sleep_quality === 'poor' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.sleep_quality === 'poor'"><img loading="lazy" src="@/assets/images/icon_sleep_no.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">I don&#x27;t sleep well</span>
                                    </label></div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 17">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a8c7">
                            <div class="form_imgdiv">
                                <img sizes="(max-width: 5760px) 100vw, 5760px" srcset="@/assets/images/pexels-olly-3771069-p-500.jpg 500w, @/assets/images/pexels-olly-3771069-p-800.jpg 800w, @/assets/images/pexels-olly-3771069-p-1080.jpg 1080w, @/assets/images/pexels-olly-3771069-p-1600.jpg 1600w, @/assets/images/pexels-olly-3771069-p-2000.jpg 2000w, @/assets/images/pexels-olly-3771069-p-2600.jpg 2600w, @/assets/images/pexels-olly-3771069-p-3200.jpg 3200w, @/assets/images/pexels-olly-3771069.jpg 5760w" alt="" src="@/assets/images/pexels-olly-3771069.jpg" loading="lazy" class="image-678" v-if="people.gender==='male'">
                                <img sizes="(max-width: 1456px) 100vw, 1456px" srcset="@/assets/images/MEdForm_sleeping.png 500w, @/assets/images/MEdForm_sleeping.png 800w, @/assets/images/MEdForm_sleeping.png 1080w, @/assets/images/MEdForm_sleeping.png 1456w" alt="" src="@/assets/images/MEdForm_sleeping.png" loading="lazy" class="image-678" v-else>
                            </div>
                            <div class="medq_questiontextdiv centered">
                                <div class="medform_questiontext short">How many hours of sleep do you usually get each night?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair"><label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('sleep_hours', 'less_than_5')" >
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.sleep_hours === 'less_than_5' }">
                                            <img v-if="people.sleep_hours === 'less_than_5'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.sleep_hours === 'less_than_5'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Less than 5 hours<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('sleep_hours', '6_to_7')" >
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.sleep_hours === '6_to_7' }">
                                            <img v-if="people.sleep_hours === '6_to_7'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.sleep_hours === '6_to_7'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">6-7 hours<br></span>
                                    </label></div>
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('sleep_hours', '8_to_9')" >
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.sleep_hours === '8_to_9' }">
                                            <img v-if="people.sleep_hours === '8_to_9'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.sleep_hours === '8_to_9'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">8-9 hours<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('sleep_hours', 'more_than_9')" >
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.sleep_hours === 'more_than_9' }">
                                            <img v-if="people.sleep_hours === 'more_than_9'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.sleep_hours === 'more_than_9'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">More than 9 hours<br></span>
                                    </label></div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 18">
                    <div class="medq_header-div center">
                        <h1 class="medform_header smaller">"I&#x27;ve tried <span class="text-span-409">every diet imaginable</span> and had lost hope. I was prescribed for GLP-1 and 20 months later, I love my new body."</h1>
                    </div>
                    <div class="form_b-a_div">
                        <div class="form-b-a">
                            <div class="b-a-form-img"><img loading="lazy" src="@/assets/images/ba_4b_1ba_4b.webp" alt="" class="image-675"><img loading="lazy" src="@/assets/images/ba_4a_1ba_4a.webp" alt="" class="image-676"></div>
                        </div>
                    </div>
                    <div class="form-subs-div">
                        <div class="medq-subs centered">Lisa<strong> lost 100 lbs</strong> and has renewed confidence<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a8ff"><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 19">
                    <div class="medq_header-div">
                        <h1 class="medform_header"><span class="medq_headerspan">GLP-1 is safe,</span> but these health conditions might prevent you from being prescribed.</h1>
                    </div>
                    <div class="form-subs-div">
                        <div class="medq-subs">Your answers are completely confidential and protected by HIPAA<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a912">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Do any of these apply to you? </div>
                            </div>
                            <div class="medq_choicesdiv">
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('none_serious')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('none_serious') }"><img v-if="hasMedicalCondition('none_serious')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('none_serious')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">None of these<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('kidney_disease')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('kidney_disease') }"><img v-if="hasMedicalCondition('kidney_disease')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('kidney_disease')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">End-stage kidney disease (on or about to be on dialysis)<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('liver_disease')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('liver_disease') }"><img v-if="hasMedicalCondition('liver_disease')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('liver_disease')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">End-stage liver disease (cirrhosis)<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('suicidal_thoughts')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('suicidal_thoughts') }"><img v-if="hasMedicalCondition('suicidal_thoughts')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('suicidal_thoughts')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Current suicidal thoughts and/or prior suicidal attempt<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('cancer')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('cancer') }"><img v-if="hasMedicalCondition('cancer')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('cancer')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Cancer (active diagnosis, active treatment, or in remission or cancer-free for less than 5 continuous years - does not apply to non-melanoma skin cancer that was considered cured via simple excision)<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('organ_transplant')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('organ_transplant') }"><img v-if="hasMedicalCondition('organ_transplant')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('organ_transplant')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">History of organ transplant on anti-rejection medication<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('gastrointestinal')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('gastrointestinal') }"><img v-if="hasMedicalCondition('gastrointestinal')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('gastrointestinal')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Severe gastrointestinal condition (gastroparesis, blockage, inflammatory bowel disease)<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition('substance_disorder')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition('substance_disorder') }"><img v-if="hasMedicalCondition('substance_disorder')" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt=""></div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition('substance_disorder')"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Current diagnosis of or treatment for alcohol, opioid, or substance use disorder/dependence<br></span>
                                </label>
                            </div>
                            <div v-if="formErrors.medical_conditions" class="error-message">{{ formErrors.medical_conditions }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 20">
                    <div class="medq_header-div">
                        <h1 class="medform_header">A few more health questions</h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9a94b">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Do any of these apply to you? </div>
                            </div>

                            <div class="medq_choicesdiv">
                                <label v-for="option in additionalConditions" :key="option.key" class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleMedicalCondition(option.key)">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasMedicalCondition(option.key) }">
                                        <img v-if="hasMedicalCondition(option.key)" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div>

                                    <input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasMedicalCondition(option.key)">

                                    <span class="medq_checkbox-text w-form-label" for="checkbox-3">
                                        {{ option.label }}<br>
                                    </span>
                                </label>
                            </div>

                            <div v-if="formErrors.medical_conditions" class="error-message">{{ formErrors.medical_conditions }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">
                                Next &gt;
                            </button>
                        </form>

                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>

                <div class="medform_question" v-show="currentStep === 21">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aa08">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Have you taken medication for weight loss within the past 4 weeks?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('weight_loss_medication', 'glp1')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_loss_medication === 'glp1' }">
                                        <img v-if="people.weight_loss_medication === 'glp1'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_loss_medication === 'glp1'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Yes, I&#x27;ve taken GLP-1 medication<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('weight_loss_medication', 'other')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_loss_medication === 'other' }">
                                        <img v-if="people.weight_loss_medication === 'other'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_loss_medication === 'other'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Yes, I&#x27;ve taken a different medication for weight loss<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field w-clearfix" @click="selectAndAdvance('weight_loss_medication', 'no')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_loss_medication === 'no' }">
                                        <img v-if="people.weight_loss_medication === 'no'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_loss_medication === 'no'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">No<br></span>
                                </label>
                            </div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 22">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aa25">
                            <div class="medq_questiontextdiv centered">
                                <div class="medform_questiontext">Within the last 3 months, have you taken opiate pain medications and/or opiate-based street drugs?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('opiate_usage', 'yes')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.opiate_usage === 'yes' }">
                                            <img v-if="people.opiate_usage === 'yes'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.opiate_usage === 'yes'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Yes<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('opiate_usage', 'no')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.opiate_usage === 'no' }">
                                            <img v-if="people.opiate_usage === 'no' " src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.opiate_usage === 'no'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">No<br></span>
                                    </label></div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 23">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aa3e">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Have you had prior weight loss surgeries?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('prior_weight_loss_surgery', 'yes')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.prior_weight_loss_surgery === 'yes' }">
                                            <img v-if="people.prior_weight_loss_surgery === 'yes'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.prior_weight_loss_surgery === 'yes'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Yes<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('prior_weight_loss_surgery', 'no')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.prior_weight_loss_surgery === 'no' }">
                                            <img v-if="people.prior_weight_loss_surgery === 'no'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.prior_weight_loss_surgery === 'no'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">No<br></span>
                                    </label></div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 24">
                    <div class="medq_header-div">
                        <h1 class="medform_header"><span class="medq_headerspan">How about weight loss programs?</span></h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aa5b">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Have you ever tried to lose weight in a weight management program (Jenny Craig, Weight Watchers, etc)? </div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('weight_management_program', 'yes')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_management_program === 'yes' }">
                                            <img v-if="people.weight_management_program === 'yes'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_management_program === 'yes'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Yes<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('weight_management_program', 'no')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_management_program === 'no' }">
                                            <img v-if="people.weight_management_program === 'no'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_management_program === 'no'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">No<br></span>
                                    </label>
                                </div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 25">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aa74">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">If clinically appropriate, are you willing to: </div>
                            </div>
                            <div class="medq_choicesdiv">
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.prevent="toggleWillingness('willing_to_reduce_calories')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.willing_to_reduce_calories === 'yes' }">
                                        <img v-if="people.willing_to_reduce_calories === 'yes'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.willing_to_reduce_calories === 'yes'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Reduce your caloric intake alongside medication<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.prevent="toggleWillingness('willing_to_increase_activity')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.willing_to_increase_activity === 'yes' }">
                                        <img v-if="people.willing_to_increase_activity === 'yes'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.willing_to_increase_activity === 'yes'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Increase your physical activity alongside medication<br></span>
                                </label>
                                <label class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.prevent="toggleWillingness('willing_lifestyle_changes')">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.willing_lifestyle_changes === 'none' }">
                                        <img v-if="people.willing_lifestyle_changes === 'none'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.willing_lifestyle_changes === 'none'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">None of the above<br></span>
                                </label>
                            </div>
                            <div v-if="formErrors.willingness" class="error-message">{{ formErrors.willingness }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 26">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aa91">
                            <div class="form_imgdiv"><img sizes="(max-width: 1024px) 100vw, 1024px" srcset="@/assets/images/bathroomscales-2048px-05881-p-500.webp 500w, @/assets/images/bathroomscales-2048px-05881-p-800.webp 800w, @/assets/images/bathroomscales-2048px-05881.webp 1024w" alt="" src="@/assets/images/bathroomscales-2048px-05881.webp" loading="lazy" class="image-678"></div>
                            <div class="medq_questiontextdiv centered">
                                <div class="medform_questiontext">Has your weight changed in the last year? </div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('weight_change_last_year', 'lost_significant')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_change_last_year === 'lost_significant' }">
                                            <img v-if="people.weight_change_last_year === 'lost_significant'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_change_last_year === 'lost_significant'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Lost a significant amount<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('weight_change_last_year', 'lost_little')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_change_last_year === 'lost_little' }">
                                            <img v-if="people.weight_change_last_year === 'lost_little'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_change_last_year === 'lost_little'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Lost a little<br></span>
                                    </label>
                                </div>
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('weight_change_last_year', 'gained_little')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_change_last_year === 'gained_little' }">
                                            <img v-if="people.weight_change_last_year === 'gained_little'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_change_last_year === 'gained_little'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Gained a little<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('weight_change_last_year', 'gained_significant')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.weight_change_last_year === 'gained_significant' }">
                                            <img v-if="people.weight_change_last_year === 'gained_significant'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.weight_change_last_year === 'gained_significant'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Gained a significant amount<br></span>
                                    </label></div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 27">
                    <div class="medq_header-div center">
                        <h1 class="medform_header smaller">&quot;Being a mom makes it so hard to stay on a diet but <span class="text-span-409">the weight vanished</span> with GLP medication!"</h1>
                    </div>
                    <div class="form_b-a_div">
                        <div class="form-b-a">
                            <div class="b-a-form-img"><img loading="lazy" src="@/assets/images/ba_5b_1ba_5b.webp" alt="" class="image-675"><img loading="lazy" src="@/assets/images/ba_5a_1ba_5a.webp" alt="" class="image-676"></div>
                        </div>
                    </div>
                    <div class="form-subs-div">
                        <div class="medq-subs centered">Michelle <strong>lost 90lbs</strong> and came off her blood pressure medication<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aac9"><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button></form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 28">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aad3">
                            <div class="form_imgdiv"><img sizes="(max-width: 612px) 100vw, 612px" srcset="@/assets/images/blood-pressure-p-500.jpeg 500w, @/assets/images/blood-pressure.jpeg 612w" alt="" src="@/assets/images/blood-pressure.jpeg" loading="lazy" class="image-678"></div>
                            <div class="medq_questiontextdiv centered">
                                <div class="medform_questiontext">What is your average blood pressure range?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('blood_pressure', 'normal')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.blood_pressure === 'normal' }">
                                            <img v-if="people.blood_pressure === 'normal'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.blood_pressure === 'normal'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">&lt;120/80 (Normal)<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('blood_pressure', 'elevated')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.blood_pressure === 'elevated' }">
                                            <img v-if="people.blood_pressure === 'elevated'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.blood_pressure === 'elevated'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">120-129/&lt;80 (Elevated)<br></span>
                                    </label></div>
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('blood_pressure', 'high_stage1')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.blood_pressure === 'high_stage1' }">
                                            <img v-if="people.blood_pressure === 'high_stage1'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.blood_pressure === 'high_stage1'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">130-139/80-89 (High Stage 1)<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('blood_pressure', 'high_stage2')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.blood_pressure === 'high_stage2' }">
                                            <img v-if="people.blood_pressure === 'high_stage2'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.blood_pressure === 'high_stage2'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">≥140/90 (High Stage 2)<br></span>
                                    </label>
                                </div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 29">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aaf9">
                            <div class="form_imgdiv"><img sizes="(max-width: 612px) 100vw, 612px" srcset="@/assets/images/heart-rate-p-500.jpeg 500w, @/assets/images/heart-rate.jpeg 612w" alt="" src="@/assets/images/heart-rate.jpeg" loading="lazy" class="image-678"></div>
                            <div class="medq_questiontextdiv centered">
                                <div class="medform_questiontext">How about your average resting heart rate? </div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('resting_heart_rate', 'slow')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.resting_heart_rate === 'slow' }">
                                            <img v-if="people.resting_heart_rate === 'slow'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.resting_heart_rate === 'slow'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">&lt;60 beats per minute (Slow)<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('resting_heart_rate', 'normal')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.resting_heart_rate === 'normal' }">
                                            <img v-if="people.resting_heart_rate === 'normal'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.resting_heart_rate === 'normal'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">60-100 beats per minute (Normal)<br></span>
                                    </label></div>
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('resting_heart_rate', 'slightly_fast')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.resting_heart_rate === 'slightly_fast' }">
                                            <img v-if="people.resting_heart_rate === 'slightly_fast'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.resting_heart_rate === 'slightly_fast'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">101-110 beats per minute (Slightly Fast)<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('resting_heart_rate', 'fast')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.resting_heart_rate === 'fast' }">
                                            <img v-if="people.resting_heart_rate === 'fast'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.resting_heart_rate === 'fast'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">&gt;110 beats per minute (Fast)<br></span>
                                    </label>
                                </div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 30">
                    <div class="medq_header-div">
                        <h1 class="medform_header"><span class="medq_headerspan">Looking good!</span> Let&#x27;s match you with the best medication.</h1>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9ab25">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Which of these is most important to you?</div>
                            </div>
                            <div class="multilinkdiv">
                                <div class="medq_linksdiv minus-third">
                                    <label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('medication_priority', 'affordability')" :class="{ 'selected': people.medication_priority === 'affordability' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.medication_priority === 'affordability' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.medication_priority === 'affordability'"><img loading="lazy" src="https://cdn.prod.website-files.com/66c5ac96534cb23d5707f11b/6895b08b02efc309c43b643a_icon_savings_blk.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Affordability<br><span class="text-span-408">Lowest price</span></span>
                                    </label>
                                    <label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('medication_priority', 'potency')" :class="{ 'selected': people.medication_priority === 'potency' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.medication_priority === 'potency' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.medication_priority === 'potency'"><img loading="lazy" src="@/assets/images/icon_muscle.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">Potency<br><span class="text-span-408">Stronger dose</span></span>
                                    </label>
                                </div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 31">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9ab44">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Do you currently take any medications?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('other_medications', 'yes')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.other_medications === 'yes' }">
                                            <img v-if="people.other_medications === 'yes'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.other_medications === 'yes'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Yes<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('other_medications', 'no')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.other_medications === 'no' }">
                                            <img v-if="people.other_medications === 'no'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.other_medications === 'no'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">No<br></span>
                                    </label>
                                </div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 32">
                    <div class="medq_header-div">
                        <h1 class="medform_header">Let&#x27;s better understand your current <span class="medq_headerspan">state of mind.</span></h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9ab62">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">How motivated are you to reach 130lbs?</div>
                            </div>
                            <div class="multilinkdiv">
                                <div class="medq_linksdiv"><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('motivation_level', 'ready')" :class="{ 'selected': people.motivation_level === 'ready' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.motivation_level === 'ready' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.motivation_level === 'ready'"><img loading="lazy" src="@/assets/images/icon_veryhappy1.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">I&#x27;m Ready!<br></span>
                                    </label><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('motivation_level', 'hopeful')" :class="{ 'selected': people.motivation_level === 'hopeful' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.motivation_level === 'hopeful' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.motivation_level === 'hopeful'"><img loading="lazy" src="@/assets/images/icon_happy1.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">I&#x27;m feeling hopeful</span>
                                    </label><label class="w-checkbox checkbox-field-medform thirds" @click="selectAndAdvance('motivation_level', 'cautious')" :class="{ 'selected': people.motivation_level === 'cautious' }">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom checkbox-16" :class="{ 'w--redirected-checked': people.motivation_level === 'cautious' }"></div><input type="checkbox" name="checkbox-4" id="checkbox-4" data-name="Checkbox 4" style="opacity:0;position:absolute;z-index:-1" :checked="people.motivation_level === 'cautious'"><img loading="lazy" src="@/assets/images/icon_sad1.svg" alt="" class="medq_linkimg"><span class="medq_checkbox-label w-form-label" for="checkbox-4">I&#x27;m cautious</span>
                                    </label></div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 33">
                    <div class="medq_header-div">
                        <h1 class="medform_header">RxPros medical providers review every form <span class="medq_headerspan">within 24 hours</span></h1>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9ab86">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext">Do you have any further information which you would like our medical team to know?</div>
                            </div>
                            <div class="medq_choicesdiv">
                                <div class="form_choicepair">
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('further_info', 'yes')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.further_info === 'yes' }">
                                            <img v-if="people.further_info === 'yes'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.further_info === 'yes'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">Yes<br></span>
                                    </label>
                                    <label class="w-checkbox medq_checkbox-field half w-clearfix" @click="selectAndAdvance('further_info', 'no')">
                                        <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': people.further_info === 'no' }">
                                            <img v-if="people.further_info === 'no'" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                        </div><input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="people.further_info === 'no'"><span class="medq_checkbox-text w-form-label" for="checkbox-3">No<br></span>
                                    </label>
                                </div>
                            </div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 34">
                    <div class="medq_header-div">
                        <h1 class="medform_header">
                            Your needs are <span class="medq_headerspan">unique,</span> and your medicine should be, too!
                        </h1>
                    </div>
                    <div class="form-subs-div">
                        <div class="medq-subs">
                            Your GLP-1 medication is personalized to your specific needs<br>
                        </div>
                    </div>

                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9aba9">
                            <div class="medq_questiontextdiv">
                                <div class="medform_questiontext smaller">
                                    Please select the following options that you are interested in
                                </div>
                            </div>

                            <div class="medq_choicesdiv">
                                <label v-for="option in interests" :key="option.key" class="w-checkbox medq_checkbox-field list-style w-clearfix" @click.stop.prevent="toggleInterest(option.key)">
                                    <div class="w-checkbox-input w-checkbox-input--inputType-custom medq_checkbox" :class="{ 'w--redirected-checked': hasInterest(option.key) }">
                                        <img v-if="hasInterest(option.key)" src="https://cdn.prod.website-files.com/67beb457c3129d45e62f8efc/69271b137c92eac0ce0e6e94_icon_CheckDot.svg" alt="">
                                    </div>

                                    <input type="checkbox" name="checkbox-3" id="checkbox-3" data-name="Checkbox 3" style="opacity:0;position:absolute;z-index:-1" :checked="hasInterest(option.key)">

                                    <span class="medq_checkbox-text w-form-label" for="checkbox-3">
                                        {{ option.label }}<br>
                                    </span>
                                </label>

                            </div>

                            <div v-if="formErrors.interests" class="error-message">{{ formErrors.interests }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">
                                Next &gt;
                            </button>
                        </form>

                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>

                <div class="medform_question" v-show="currentStep === 35">
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9abe4">
                            <div class="medform_questionsdiv">
                                <div class="medform_questiontext">What is your date of birth?</div>
                            </div>
                            <div class="choice_flex">
                                <div class="choice_half-div"><label for="Feet" class="medform_field-label">Month </label><select id="Feet" name="Feet" data-name="Feet" class="select-field-12 w-select" v-model="people.dob.mm">
                                        <option value="">Select one...</option>
                                        <option value="01">January</option>
                                        <option value="02">February</option>
                                        <option value="03">March</option>
                                        <option value="04">April</option>
                                        <option value="05">May</option>
                                        <option value="06">June</option>
                                        <option value="07">July</option>
                                        <option value="08">August</option>
                                        <option value="09">September</option>
                                        <option value="10">October</option>
                                        <option value="11">November</option>
                                        <option value="12">December</option>
                                    </select></div>
                                <div class="choice_half-div"><label for="Day" class="medform_field-label">Day</label><input class="text-field-67 w-input" maxlength="2" name="Day" data-name="Day" placeholder="01" type="tel" inputmode="numeric" id="Day" v-model="people.dob.dd" @keypress="numericOnly"></div>
                            </div><label for="Year" class="medform_field-label">Year</label><input class="text-field-67 w-input" maxlength="4" name="Year" data-name="Year" placeholder="1965" type="tel" inputmode="numeric" id="Year" v-model="people.dob.yyyy" @keypress="numericOnly">
                            <div v-if="formErrors.dob" class="error-message">{{ formErrors.dob }}</div>
                            <button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 36">
                    <div class="medq_header-div center">
                        <h1 class="medform_header"><span class="medq_headerspan">Your Medical Review<br></span></h1>
                    </div>
                    <div class="form-subs-div short-pad">
                        <div class="medq-subs short-pad"><strong>BMI</strong>: 29.05<br></div>
                        <div class="medq-subs short-pad"><strong>Current Weight: </strong>180lbs<br></div>
                        <div class="medq-subs short-pad"><strong>Goal Weight: </strong>130lbs <span class="text-span-410">within 18.52 weeks</span><br></div>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-subs-div short-pad">
                        <div class="medq-subs short-pad">You are a <strong>strong candidate</strong> for medical weight loss with a 94% chance of successful treatment if qualified.<br></div>
                    </div>
                    <div class="form-divider"></div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9ac1d">
                            <div class="medform_questionsdiv">
                                <div class="medform_questiontext">Let&#x27;s proceed to check your eligibility.</div>
                            </div>
                            <div class="choice_flex">
                                <div class="choice_half-div"><label for="fname" class="medform_field-label">First Name</label><input class="text-field-67 w-input" maxlength="256" name="fname" data-name="fname" placeholder="First name" type="text" id="fname" v-model="people.first_name"></div>
                                <div class="choice_half-div"><label for="lname" class="medform_field-label">Last Name</label><input class="text-field-67 w-input" maxlength="256" name="lname" data-name="lname" placeholder="Last name" type="text" id="lname" v-model="people.last_name"></div>
                            </div>
                            <div v-if="formErrors.first_name" class="error-message">{{ formErrors.first_name }}</div>
                            <div v-if="formErrors.last_name" class="error-message">{{ formErrors.last_name }}</div>
                            <label for="Year" class="medform_field-label">What state will your medication be shipped to? </label>
                            <select id="State-4" name="State-4" data-name="State 4" class="select-field-12 pad-down w-select" v-model="people.state">
                                <option value="">State...</option>
                                <option v-for="(value, key) in allState" :value="value" :key="value">{{ key }}</option>
                            </select>
                            <div v-if="formErrors.state" class="error-message">{{ formErrors.state }}</div>
                            <div class="text-block-1669">Your information is never shared and is protected by HIPAA.</div><button type="button" @click.prevent="nextStep" class="submit-button-22 w-button">Next &gt;</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div class="medform_question" v-show="currentStep === 37">
                    <div class="medq_header-div">
                        <h1 class="medform_header"><span class="medq_headerspan">{{ people.first_name }}, </span>how can you be reached if necessary?</h1>
                    </div>
                    <div class="form-subs-div short-pad">
                        <div class="medq-subs short-pad">You are a <strong>strong candidate</strong> for medical weight loss with a 94% chance of successful treatment if qualified.<br></div>
                    </div>
                    <div class="form-block-24 w-form">
                        <form id="email-form" name="email-form" data-name="Email Form" method="get" data-wf-page-id="692719c3eb7d14c4bb20e5e8" data-wf-element-id="746d7247-0f2f-7d93-dc78-36ee5df9ac44">
                            <label for="email" class="medform_field-label">Email</label>
                            <input class="text-field-67 w-input" maxlength="256" name="email" data-name="email" placeholder="Email" type="email" id="email" v-model="people.email" @blur="checkEmailOnBlur" :class="{ 'email-error': emailCheckError }">
                            <div v-if="formErrors.email" class="error-message">{{ formErrors.email }}</div>
                            <label for="num-field" class="medform_field-label">Phone</label>
                            <input class="text-field-67 w-input" maxlength="17" name="num-field" placeholder="(XXX) XXX-XXXX" type="text" inputmode="tel" autocomplete="off" id="num-field" :value="people.phone" @input="handlePhoneInput">
                            <div v-if="formErrors.phone" class="error-message">{{ formErrors.phone }}</div>
                            <label class="w-checkbox sms-consent-checkbox" :class="{ 'field-error': formErrors.emailConsent, 'is-shaking': shakeConsent }" @animationend="shakeConsent = false">
                                <input type="checkbox" v-model="people.agreed_to_email" name="checkbox-sms" id="checkbox-sms" data-name="Checkbox SMS" class="w-checkbox-input">
                                <span class="sms-consent-label w-form-label" for="checkbox-sms">By checking the box, you agree that RXPros can contact you at the telephone number provided using an autodialer, AI technology, artificial voice and prerecorded calls or text/SMS messages with information and offers. Msg. and data rates apply. You also agree to our <a href="https://www.rxpros.com/privacy" target="_blank">Privacy Policy</a> and <a href="https://www.rxpros.com/terms" target="_blank">Terms</a>.</span>
                            </label>
                            <div v-if="formErrors.emailConsent" class="error-message">{{ formErrors.emailConsent }}</div>
                            <button type="button" :disabled="checkingEmail" @click.prevent="submitForm" class="submit-button-22 w-button">{{ checkingEmail ? 'Please wait...' : 'Submit' }}</button>
                        </form>
                        <div class="w-form-done">
                            <div>Thank you! Your submission has been received!</div>
                        </div>
                        <div class="w-form-fail">
                            <div>Oops! Something went wrong while submitting the form.</div>
                        </div>
                    </div>
                </div>
                <div v-if="currentStepError" class="error-message step-error">{{ currentStepError }}</div>
            </div>
            <div style="height: 180px;"></div>
        </div>

    </div>

    <!-- Paid User Modal -->
    <div v-if="showPaidUserModal" class="modal-overlay" @click.self="showPaidUserModal = false">
        <div class="modal-content paid-user-modal">
            <button class="modal-close" @click="showPaidUserModal = false">&times;</button>
            <div class="modal-body">
                <h2 class="modal-title">Welcome back!</h2>
                <p v-if="modalMode === 'wrong_role'">This email is associated with a {{ modalRole }} account. Please log in to continue, or use a different email.</p>
                <p v-else>You already have an account with us. Log in to manage your treatment, track shipments, and message your care team.</p>
                <button class="modal-btn modal-btn-primary" @click="goToLogin">Log In</button>
                <button class="modal-btn modal-btn-secondary" @click="showPaidUserModal = false">Not me — use a different email</button>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import state from '@/utils/state'
import { checkEmail } from "@/utils/checkEmail"
import { cleanUsPhone, formatUsPhoneInput, isValidUsPhone } from "@/utils/phone"
import { syncFreeNadOffer } from "@/utils/freeNadLife"
import {
    mapActions
} from 'vuex'

export default {
    name: 'WeightLossForm3',
    data() {
        return {
            allState: state,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            appName: process.env.VUE_APP_COMPANY,
            appMainWeb: process.env.VUE_APP_HOMEPAGE,
            currentStep: 1,
            totalSteps: 37,
            formErrors: {},
            advanceTimer: null,
            storageKey: 'rxpros_weightloss_style3_progress',
            shakeConsent: false,
            isSubmitting: false,
            checkingEmail: false,
            emailCheckError: false,
            showPaidUserModal: false,
            modalMode: 'paid',
            modalRole: '',
            interests: [{
                    key: 'muscle_mass',
                    label: 'Maintaining muscle mass as I lose weight'
                },
                {
                    key: 'no_injection',
                    label: 'Would prefer not to inject'
                },
                {
                    key: 'side_effects',
                    label: 'Managing potential side effects such as nausea/vomiting'
                },
                {
                    key: 'longevity',
                    label: 'Assist with aging and longevity (cellular/DNA damage, immune system dysfunction, etc)'
                },
                {
                    key: 'cognitive',
                    label: 'Improving cognitive function and mental clarity'
                },
                {
                    key: 'energy',
                    label: 'Improving energy levels'
                },
                {
                    key: 'hormonal',
                    label: 'Regulating menses and hormonal status'
                },
                {
                    key: 'sleep',
                    label: 'Improving sleep quality'
                },
                {
                    key: 'consult',
                    label: "I'm not sure - I'd like to discuss formulation options with a clinician via a live virtual consult"
                }
            ],
            additionalConditions: [{
                    key: 'none_additional',
                    label: 'None of these'
                },
                {
                    key: 'gallbladder',
                    label: 'Gallbladder disease'
                },
                {
                    key: 'hypertension',
                    label: 'Hypertension (high blood pressure)'
                },
                {
                    key: 'seizures',
                    label: 'Seizures'
                },
                {
                    key: 'glaucoma',
                    label: 'Glaucoma'
                },
                {
                    key: 'sleep_apnea',
                    label: 'Sleep apnea'
                },
                {
                    key: 'type2_diabetes_no_insulin',
                    label: 'Type 2 diabetes (not on insulin)'
                },
                {
                    key: 'type2_diabetes_on_insulin',
                    label: 'Type 2 diabetes (on insulin)'
                },
                {
                    key: 'type1_diabetes',
                    label: 'Type 1 diabetes'
                },
                {
                    key: 'diabetic_retinopathy',
                    label: 'Diabetic retinopathy (diabetic eye disease), damage to the optic nerve from trauma or reduced blood flow, or blindness'
                },
                {
                    key: 'warfarin',
                    label: 'Use of the blood thinner warfarin (Coumadin/Jantoven)'
                },
                {
                    key: 'pancreatitis',
                    label: 'History of or current pancreatitis'
                },
                {
                    key: 'thyroid_history',
                    label: 'Personal or family history of thyroid cyst/nodule, thyroid cancer, medullary thyroid carcinoma, or multiple endocrine neoplasia syndrome type 2'
                },
                {
                    key: 'gout',
                    label: 'Gout'
                },
                {
                    key: 'high_cholesterol',
                    label: 'High cholesterol or triglycerides'
                },
                {
                    key: 'depression',
                    label: 'Depression'
                },
                {
                    key: 'head_injury',
                    label: 'Head injury'
                },
                {
                    key: 'tumor_infection_brain',
                    label: 'Tumor/infection in brain/spinal cord'
                },
                {
                    key: 'low_sodium',
                    label: 'Low sodium'
                },
                {
                    key: 'liver_disease',
                    label: 'Liver disease, including fatty liver'
                },
                {
                    key: 'kidney_disease',
                    label: 'Kidney disease'
                },
                {
                    key: 'tachycardia',
                    label: 'Elevated resting heart rate (tachycardia)'
                },
                {
                    key: 'coronary_artery_disease',
                    label: 'Coronary artery disease or heart attack/stroke in last 2 years'
                },
                {
                    key: 'medication_allergy',
                    label: 'Allergic to any medication'
                },
                {
                    key: 'congestive_heart_failure',
                    label: 'Congestive heart failure'
                },
                {
                    key: 'qt_prolongation',
                    label: 'QT prolongation or other heart rhythm disorder'
                },
                {
                    key: 'hospitalization',
                    label: 'Hospitalization within the last 1 year'
                },
                {
                    key: 'hiv',
                    label: 'Human immunodeficiency virus (HIV)'
                },
                {
                    key: 'acid_reflux',
                    label: 'Acid reflux'
                },
                {
                    key: 'asthma',
                    label: 'Asthma/reactive airway disease'
                },
                {
                    key: 'urinary_incontinence',
                    label: 'Urinary stress incontinence'
                },
                {
                    key: 'pcos',
                    label: 'Polycystic ovarian syndrome (PCOS)'
                },
                {
                    key: 'low_testosterone',
                    label: 'Clinically proven low testosterone'
                },
                {
                    key: 'osteoarthritis',
                    label: 'Osteoarthritis'
                },
                {
                    key: 'constipation',
                    label: 'Constipation'
                }
            ],
            people: {
                form_type: "weightloss_style3",
                first_name: '',
                last_name: '',
                email: '',
                phone: '',
                phone_parts: {
                    areaCode: '',
                    prefix: '',
                    line: ''
                },
                heightInInches: '',
                height: {
                    foot: '',
                    inches: ''
                },
                weight: '',
                bmi: '',
                gender: '',
                agreed_to_text: "Yes",
                agreed_to_email: false,
                desired_weight: '',
                state: '',
                agreed_to_terms: true,
                form_step2_agree: true,
                dobMMDDYYYY: 'NA',
                source_web: 2,
                ip_address: '',
                age: '',
                tracking_session_id: '',
                user_agent: '',
                dob: {
                    mm: '',
                    dd: '',
                    yyyy: ''
                },
                medical_conditions: [],
                interests: [],
                weight_loss_medication: '',
                opiate_usage: '',
                pregnancy_status: '',
                other_medications: '',
                prior_weight_loss_surgery: '',
                weight_management_program: '',
                age_range: '',
                priority: '',
                medication_priority: '',
                primary_reason: '',
                weight_loss_pace: '',
                sleep_quality: '',
                sleep_hours: '',
                blood_pressure: '',
                resting_heart_rate: '',
                weight_change_last_year: '',
                motivation_level: '',
                willing_to_increase_activity: '',
                willing_to_reduce_calories: '',
                willing_lifestyle_changes: '',
                further_info: ''
            }
        }
    },

    async mounted() {
        // The free NAD+ offer link (?offer=&nad=) rides to the payment page in the tab's
        // storage, because the funnel drops the query on the way.
        syncFreeNadOffer(this.$route.query);
        this.loadProgress();
        if (this.$route.query.sema) {
            await this.$store.dispatch('addSemaOffer', this.$route.query.sema);
        }
        if (this.$route.query.tir) {
            await this.$store.dispatch('addTirOffer', this.$route.query.tir);
        }
        this.getIpAddress();
        this.people.user_agent = navigator.userAgent;
    },

    computed: {
        isFormErrorEmpty() {
            return Object.keys(this.formErrors).length === 0;
        },
        medicalGroups() {
            const symptom = {
                none: 'none_of_these',
                members: ['low_libido', 'hair_loss', 'skin_issues', 'cognition_issues']
            };
            return {
                4: symptom,
                6: symptom,
                19: {
                    none: 'none_serious',
                    members: ['kidney_disease', 'liver_disease', 'suicidal_thoughts', 'cancer', 'organ_transplant', 'gastrointestinal', 'substance_disorder']
                },
                20: {
                    none: 'none_additional',
                    members: this.additionalConditions
                        .map(option => option.key)
                        .filter(key => key !== 'none_additional')
                }
            };
        },
        // Single-choice steps validated by validateRequired() have no inline error div.
        // This surfaces that error below the Next button. The fields here are disjoint
        // from the fields shown by inline error divs, so it never double-displays.
        currentStepError() {
            const singleChoiceFields = [
                'pregnancy_status', 'priority', 'medication_priority', 'primary_reason', 'weight_loss_pace',
                'sleep_quality', 'sleep_hours', 'weight_loss_medication', 'opiate_usage',
                'prior_weight_loss_surgery', 'weight_management_program', 'weight_change_last_year',
                'blood_pressure', 'resting_heart_rate', 'other_medications', 'motivation_level',
                'further_info'
            ];
            const key = Object.keys(this.formErrors)[0];
            return key && singleChoiceFields.includes(key) ? this.formErrors[key] : '';
        },
        fastWeeksToGoal() {
            const weight = parseFloat(this.people.weight);
            const desired = parseFloat(this.people.desired_weight);

            // If data is missing or they don't actually need to lose weight
            if (isNaN(weight) || isNaN(desired) || weight <= desired) {
                return 0;
            }

            const weeklyLossFast = 3.6; // lbs/week on a "faster" plan (upper end of GLP-1 range)
            const weeks = (weight - desired) / weeklyLossFast;

            return weeks.toFixed(1); // e.g. "15.3"
        },
        isValidPhone() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            return (
                areaCode?.length === 3 &&
                prefix?.length === 3 &&
                line?.length === 4 &&
                /^\d+$/.test(areaCode) &&
                /^\d+$/.test(prefix) &&
                /^\d+$/.test(line)
            );
        },
        weeksToLoseWeight() {
            const weightToLose = this.people.weight - this.people.desired_weight;

            if (weightToLose <= 0) return 0;

            const lossRate = 1.25; // average lbs/week on GLP-1
            const weeks = weightToLose / lossRate;

            return weeks.toFixed(1); // e.g. "12.8"
        },
        phoneNumber() {
            const {
                areaCode,
                prefix,
                line
            } = this.people.phone_parts;
            if (!this.isValidPhone) return '';
            return `${areaCode}${prefix}${line}`;
        },

        isValidEmail() {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(this.people.email);
        },

        calculatedBMI() {
            if (this.people.weight && this.people.heightInInches) {
                const heightInInches = parseFloat(this.people.heightInInches);
                const weightInPounds = parseFloat(this.people.weight);
                return (weightInPounds / (heightInInches * heightInInches)) * 703;
            }
            return null;
        },

        progressPercentage() {
            return Math.round((this.currentStep / this.totalSteps) * 100);
        },

        progressStage() {
            if (this.currentStep <= 5) return 'Start';
            if (this.currentStep <= 15) return 'Preliminary';
            if (this.currentStep <= 25) return 'Health';
            if (this.currentStep <= 35) return 'Details';
            return 'Eligibility';
        }
    },

    watch: {
        'people.agreed_to_email'(newVal) {
            if (newVal && this.formErrors.emailConsent) {
                this.$delete(this.formErrors, 'emailConsent');
            }
        },
        currentStep() {
            this.saveProgress();
        },
        people: {
            handler() {
                this.saveProgress();
            },
            deep: true
        }
    },

    methods: {
        ...mapActions(['setCartVisibility']),

        async getIpAddress() {
            try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                this.people.ip_address = data.ip;
                return data.ip;
            } catch (error) {
                console.error('Error getting IP:', error);
            }
        },

        generateSessionId() {
            return 'sess_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        },

        nextStep() {
            if (!this.validateCurrentStep()) return;

            const gender = this.people.gender;
            const pace = this.people.weight_loss_pace;
            let next = this.currentStep;

            // --- Gender-based branching (steps 3–7) ---
            if (next === 3) {
                // After gender question:
                // male -> step 4, female -> skip male step and go to step 5
                if (gender === 'female') {
                    next = 5; // 3 -> 5 (skip male-only step 4)
                } else {
                    next = 4; // 3 -> 4 (male path)
                }
            } else if (next === 4 && gender === 'male') {
                // Male specific step 4 -> jump to common step 7
                next = 7; // 4 -> 7 (skip female-only 5 & 6)
            } else if (next === 5 && gender === 'female') {
                // Female safety step -> female symptoms step
                next = 6; // 5 -> 6
            } else if (next === 6) {
                // Done with female-only step -> go to common step 7
                next = 7; // 6 -> 7

                // --- Pace-based branching (step 13) ---
            } else if (next === 13) {
                if (pace === 'want_faster') {
                    next = 15; // “I want it faster”
                } else if (pace === 'too_fast') {
                    next = 16; // “That’s too fast”
                } else {
                    // Default / “That works for me”
                    next = 14; // Normal pace
                }

                // --- Default behaviour ---
            } else if (next === 14) {
                next = 16;
            } else {
                next++;
            }

            if (next > this.totalSteps) {
                this.submitForm();
                return;
            }

            this.currentStep = next;
            this.scrollToTop();
        },

        previousStep() {
            if (this.currentStep <= 1) return;

            const gender = this.people.gender;
            let prev = this.currentStep;

            if (gender === 'male') {
                // Male path: from 7 go back to 4 (skip 5 & 6)
                if (prev === 7) {
                    prev = 4;
                } else {
                    prev--;
                }
            } else if (gender === 'female') {
                // Female path:
                // - from 7 go back to 6
                // - from 5 go back to 3 (skip male-only 4)
                if (prev === 7) {
                    prev = 6;
                } else if (prev === 5) {
                    prev = 3;
                } else {
                    prev--;
                }
            } else {
                // Fallback for unknown gender
                prev--;
            }

            if (prev < 1) prev = 1;

            this.currentStep = prev;
            this.scrollToTop();
        },

        goToStep(step) {
            if (step >= 1 && step <= this.totalSteps) {
                this.currentStep = step;
                this.scrollToTop();
            }
        },

        scrollToTop() {
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        },

        numericOnly(event) {
            const charCode = event.which ? event.which : event.keyCode;
            if (charCode < 48 || charCode > 57) {
                event.preventDefault();
            }
        },

        goToLogin() {
            this.showPaidUserModal = false;
            this.$router.push({ path: '/login', query: { email: this.people.email } });
        },

        async checkEmailOnBlur() {
            this.emailCheckError = false;
            this.formErrors.email = '';
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(this.people.email)) return;

            const result = await checkEmail(this.people.email);
            if (!result.proceed) {
                this.emailCheckError = true;
                if (result.reason === 'wrong_role') {
                    this.formErrors.email = `This email is associated with a ${result.role} account. Please use a different email.`;
                    this.modalMode = 'wrong_role';
                    this.modalRole = result.role;
                    this.showPaidUserModal = true;
                } else if (result.reason === 'paid_user') {
                    this.formErrors.email = 'This email already has an account.';
                    this.modalMode = 'paid';
                    this.showPaidUserModal = true;
                }
            }
        },

        handlePhoneInput(event) {
            // Keep a leading 1 visible as "+1 " instead of swallowing the keypress.
            // cleanUsPhone strips it before submit, so the backend gets 10 digits.
            const formatted = formatUsPhoneInput(event.target.value);
            this.people.phone = formatted;
            event.target.value = formatted;
        },

        validateCurrentStep() {
            this.formErrors = {};

            switch (this.currentStep) {
                case 1:
                    return this.validateHeightWeight();
                case 2:
                    return this.validateGoalWeight();
                case 3:
                    return this.validateGenderAge();
                case 4:
                case 6:
                    return this.validateMedicalAnswered();
                case 5:
                    return this.validateRequired('pregnancy_status', 'Please select an option');
                case 7:
                    return this.validateRequired('priority', 'Please select an option');
                case 11:
                    return this.validateRequired('primary_reason', 'Please select an option');
                case 12:
                    return this.validateRequired('weight_loss_pace', 'Please select an option');
                case 16:
                    return this.validateRequired('sleep_quality', 'Please select an option');
                case 17:
                    return this.validateRequired('sleep_hours', 'Please select an option');
                case 19:
                    return this.validateMedicalAnswered();
                case 20:
                    return this.validateMedicalAnswered();
                case 21:
                    return this.validateRequired('weight_loss_medication', 'Please select an option');
                case 22:
                    return this.validateRequired('opiate_usage', 'Please select an option');
                case 23:
                    return this.validateRequired('prior_weight_loss_surgery', 'Please select an option');
                case 24:
                    return this.validateRequired('weight_management_program', 'Please select an option');
                case 25:
                    return this.validateWillingness();
                case 26:
                    return this.validateRequired('weight_change_last_year', 'Please select an option');
                case 28:
                    return this.validateRequired('blood_pressure', 'Please select an option');
                case 29:
                    return this.validateRequired('resting_heart_rate', 'Please select an option');
                case 30:
                    return this.validateRequired('medication_priority', 'Please select an option');
                case 31:
                    return this.validateRequired('other_medications', 'Please select an option');
                case 32:
                    return this.validateRequired('motivation_level', 'Please select an option');
                case 33:
                    return this.validateRequired('further_info', 'Please select an option');
                case 34:
                    return this.validateInterests();
                case 35:
                    return this.validateDOB();
                case 36:
                    return this.validateNameState();
                default:
                    return true;
            }
        },

        validateHeightWeight() {
            if (window.tracking) {
                window.tracking.event('questionnaire_start', {});
            }

            if (!this.people.height.foot || !this.people.height.inches) {
                this.formErrors.height = 'Please select your height';
                return false;
            }
            if (!this.people.weight || this.people.weight < 50 || this.people.weight > 500) {
                this.formErrors.weight = 'Please enter a valid weight';
                return false;
            }
            this.calculateBMI();

            if (window.tracking) {
                window.tracking.event('bmi_confirmation', {});
            }

            return true;
        },

        validateGoalWeight() {
            if (!this.people.desired_weight || this.people.desired_weight < 50 || this.people.desired_weight > 500) {
                this.formErrors.desired_weight = 'Please enter a valid goal weight';
                return false;
            }
            return true;
        },

        validateDOB() {
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob;

            if (!mm || !dd || !yyyy) {
                this.formErrors.dob = 'Please enter a complete date of birth';
                return false;
            }

            const paddedMonth = String(mm).padStart(2, '0');
            const paddedDay = String(dd).padStart(2, '0');

            if (!this.isValidDate(paddedMonth, paddedDay, yyyy)) {
                this.formErrors.dob = 'Please enter a valid date of birth';
                return false;
            }

            this.people.dobMMDDYYYY = `${paddedMonth}/${paddedDay}/${yyyy}`;
            this.calculateAge();
            return true;
        },

        isValidDate(month, day, year) {
            const date = new Date(year, month - 1, day);
            const today = new Date();

            if (!(date instanceof Date) || isNaN(date) ||
                date.getMonth() !== month - 1 ||
                date.getDate() !== parseInt(day) ||
                date.getFullYear() !== parseInt(year)) {
                return false;
            }

            const currentYear = today.getFullYear();
            if (year < 1924 || year > currentYear) {
                return false;
            }

            if (date > today) {
                return false;
            }

            return true;
        },

        calculateBMI() {
            const heightInInches = (parseInt(this.people.height.foot) * 12) + parseInt(this.people.height.inches);
            const weightInPounds = parseInt(this.people.weight);
            this.people.bmi = ((weightInPounds * 703) / (heightInInches * heightInInches)).toFixed(2);
            this.people.heightInInches = heightInInches;
        },

        calculateAge() {
            const {
                mm,
                dd,
                yyyy
            } = this.people.dob;
            const birthDate = new Date(yyyy, mm - 1, dd);
            const today = new Date();
            let age = today.getFullYear() - birthDate.getFullYear();
            const monthDiff = today.getMonth() - birthDate.getMonth();

            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            this.people.age = age;
        },

        toggleMedicalCondition(condition) {
            const index = this.people.medical_conditions.indexOf(condition);
            if (index > -1) {
                this.people.medical_conditions.splice(index, 1);
            } else {
                const group = this.medicalGroups[this.currentStep];
                if (group) {
                    if (condition === group.none) {
                        // "None of these" selected → clear every other option in this group
                        this.people.medical_conditions = this.people.medical_conditions
                            .filter(key => !group.members.includes(key));
                    } else {
                        // a real condition selected → clear this group's "None of these"
                        const noneIndex = this.people.medical_conditions.indexOf(group.none);
                        if (noneIndex > -1) this.people.medical_conditions.splice(noneIndex, 1);
                    }
                }
                this.people.medical_conditions.push(condition);
            }
        },

        hasMedicalCondition(condition) {
            return this.people.medical_conditions.includes(condition);
        },

        toggleWillingness(field) {
            if (field === 'willing_lifestyle_changes') {
                // "None of the above" → toggle, and clear the two positive options
                if (this.people.willing_lifestyle_changes === 'none') {
                    this.$set(this.people, 'willing_lifestyle_changes', '');
                } else {
                    this.$set(this.people, 'willing_lifestyle_changes', 'none');
                    this.$set(this.people, 'willing_to_reduce_calories', '');
                    this.$set(this.people, 'willing_to_increase_activity', '');
                }
            } else {
                // a positive option → toggle, and clear "None of the above"
                if (this.people[field] === 'yes') {
                    this.$set(this.people, field, '');
                } else {
                    this.$set(this.people, field, 'yes');
                    this.$set(this.people, 'willing_lifestyle_changes', '');
                }
            }
        },

        toggleInterest(interest) {
            const index = this.people.interests.indexOf(interest);
            if (index > -1) {
                this.people.interests.splice(index, 1);
            } else {
                this.people.interests.push(interest);
            }
        },

        hasInterest(interest) {
            return this.people.interests.includes(interest);
        },

        selectOption(field, value) {
            this.$set(this.people, field, value);
        },

        selectAndAdvance(field, value) {
            this.$set(this.people, field, value);
            if (this.advanceTimer) clearTimeout(this.advanceTimer);
            this.advanceTimer = setTimeout(() => {
                this.advanceTimer = null;
                this.nextStep();
            }, 300);
        },

        saveProgress() {
            try {
                const progressData = {
                    currentStep: this.currentStep,
                    people: this.people,
                    savedAt: new Date().toISOString(),
                    version: '1.0'
                };
                localStorage.setItem(this.storageKey, JSON.stringify(progressData));
            } catch (error) {
                console.error('Error saving progress:', error);
            }
        },

        loadProgress() {
            try {
                const saved = localStorage.getItem(this.storageKey);
                if (!saved) return;

                const progressData = JSON.parse(saved);
                if (!progressData ||
                    typeof progressData.currentStep !== 'number' ||
                    typeof progressData.people !== 'object' ||
                    !progressData.savedAt) {
                    this.clearProgress();
                    return;
                }

                // Discard progress older than 7 days
                const hoursSinceSave = (Date.now() - new Date(progressData.savedAt).getTime()) / (1000 * 60 * 60);
                if (hoursSinceSave > 168) {
                    this.clearProgress();
                    return;
                }

                this.people = Object.assign({}, this.people, progressData.people);
                if (progressData.currentStep >= 1 && progressData.currentStep <= this.totalSteps) {
                    this.currentStep = progressData.currentStep;
                }
            } catch (error) {
                console.error('Error loading progress:', error);
                this.clearProgress();
            }
        },

        clearProgress() {
            try {
                localStorage.removeItem(this.storageKey);
            } catch (error) {
                console.error('Error clearing progress:', error);
            }
        },

        validateRequired(field, message) {
            if (!this.people[field]) {
                this.$set(this.formErrors, field, message);
                return false;
            }
            return true;
        },

        validateGenderAge() {
            let valid = true;
            if (!this.people.gender) {
                this.$set(this.formErrors, 'gender', 'Please select your gender');
                valid = false;
            }
            if (!this.people.age_range) {
                this.$set(this.formErrors, 'age_range', 'Please select your age range');
                valid = false;
            }
            return valid;
        },

        validateMedicalAnswered() {
            const group = this.medicalGroups[this.currentStep];
            const groupKeys = group ? [group.none, ...group.members] : [];
            const hasSelection = this.people.medical_conditions
                .some(key => groupKeys.includes(key));
            if (!hasSelection) {
                this.$set(this.formErrors, 'medical_conditions', 'Please select at least one option');
                return false;
            }
            return true;
        },

        validateWillingness() {
            if (!this.people.willing_to_reduce_calories &&
                !this.people.willing_to_increase_activity &&
                !this.people.willing_lifestyle_changes) {
                this.$set(this.formErrors, 'willingness', 'Please select at least one option');
                return false;
            }
            return true;
        },

        validateInterests() {
            if (!this.people.interests.length) {
                this.$set(this.formErrors, 'interests', 'Please select at least one option');
                return false;
            }
            return true;
        },

        validateNameState() {
            let valid = true;
            if (!this.people.first_name || !this.people.first_name.trim()) {
                this.$set(this.formErrors, 'first_name', 'Please enter your first name');
                valid = false;
            }
            if (!this.people.last_name || !this.people.last_name.trim()) {
                this.$set(this.formErrors, 'last_name', 'Please enter your last name');
                valid = false;
            }
            if (!this.people.state) {
                this.$set(this.formErrors, 'state', 'Please select your state');
                valid = false;
            }
            return valid;
        },

        updatePhonePart(part, value) {
            const digits = value.replace(/\D/g, '');
            this.people.phone_parts[part] = digits;
        },
        
        async submitForm() {
            this.isSubmitting = true;
            this.formErrors = {};

            if (!this.isValidEmail) {
                this.$set(this.formErrors, 'email', 'Please enter a valid email address');
                this.isSubmitting = false;
                return;
            }

            if (!isValidUsPhone(this.people.phone)) {
                this.$set(this.formErrors, 'phone', 'Please enter a complete, valid phone number');
                this.isSubmitting = false;
                return;
            }

            if (!this.people.agreed_to_email) {
                this.$set(this.formErrors, 'emailConsent', 'Please check the consent box to continue');
                this.shakeConsent = true;
                this.isSubmitting = false;
                return;
            }

            // Check email against existing accounts
            this.checkingEmail = true;
            try {
                const emailResult = await checkEmail(this.people.email);
                if (!emailResult.proceed) {
                    this.emailCheckError = true;
                    if (emailResult.reason === 'wrong_role') {
                        this.modalMode = 'wrong_role';
                        this.modalRole = emailResult.role;
                        this.showPaidUserModal = true;
                        this.isSubmitting = false;
                        return;
                    }
                    if (emailResult.reason === 'paid_user') {
                        this.modalMode = 'paid';
                        this.showPaidUserModal = true;
                        this.isSubmitting = false;
                        return;
                    }
                }
            } finally {
                this.checkingEmail = false;
            }

            try {
                if (this.isValidPhone) {
                    this.people.phone = this.phoneNumber;
                }

                
                try{
                       this.people.tracking_session_id = await window.tracking.assertSession();
                    }catch(error){
                        if (window.trackingSessionId) {
                            this.people.tracking_session_id = window.trackingSessionId;
                        }
                    }

                // Normalize phone to 10 digits (no leading 1) before sending
                this.people.phone = cleanUsPhone(this.people.phone);

                const response = await this.$axios.post(`${this.baseUrl}/api/intake-form`, this.people, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
                if (response.data.status === 'success') {
                    this.clearProgress();

                    try {
                        if (window.tracking) {
                            window.tracking.event('questionnaire_end', {});
                        }
                    } catch (error) {
                        console.log(error)
                    }
                    try{
                        this.saveAllResponses(this.people, response.data.user.id);
                    }catch(error){
                        console.log(error)
                    }
                    this.people.id = response.data.user.id;
                    this.$store.dispatch("doLogin", response.data);
                    this.$router.push({
                        name: 'reportPage',
                        query: {
                            'desiredWeight': this.people.desired_weight
                        }
                    });
                }
                
            } catch (error) {
                console.error('Error submitting form:', error);
                this.formErrors.submit = 'An error occurred. Please try again.';
            } finally {
                this.isSubmitting = false;
            }
        },
        async saveAllResponses(people, user_id){
            try{
                // Destructure to remove unwanted fields
                /* eslint-disable no-unused-vars */
                const {
                    first_name,
                    last_name,
                    email,
                    phone,
                    weight,
                    bmi,
                    gender,
                    agreed_to_text,
                    agreed_to_email,
                    desired_weight,
                    state,
                    agreed_to_terms,
                    form_step2_agree,
                    dobMMDDYYYY,
                    source_web,
                    ip_address,
                    age,
                    tracking_session_id,
                    user_agent,
                    dob,
                    ...filteredPeople
                } = people;
                /* eslint-enable no-unused-vars */

                let postData = { ...filteredPeople };

                Object.keys(postData).forEach(key => {
                    if (Array.isArray(postData[key])) {
                        postData[key] = postData[key].join(', ');
                    }
                });


                await this.$axios.post(`${this.baseUrl}/api/intake-form-full/${user_id}`, postData, {
                    headers: {
                        'Content-Type': 'application/json',
                        "Access-Control-Allow-Origin": "*"
                    }
                })
            }catch(error){
                console.log(error)
            }
        }
    }
}
</script>

<style scoped>
.sms-disclaimer {
    color: #6c7e8d;
    font-size: 9px;
    line-height: 13px;
    margin-top: 6px;
    margin-bottom: 20px;
}
.sms-disclaimer a {
    color: #6c7e8d;
    text-decoration: underline;
}
.selected {
    background-color: #e8f4ff !important;
    border: 2px solid #0066cc !important;
    box-shadow: 0 2px 8px rgba(0, 102, 204, 0.3) !important;
    transform: scale(1.01) !important;
}

/* Error message styling */
.error-message {
    color: #dc3545;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
    font-weight: 500;
}

/* Active stage indicator: green ring + filled dot on the current step group */
.progress_circle.current {
    border-color: var(--logo-green);
}

.progress_circle.current::after {
    content: "";
    width: 10px;
    height: 10px;
    border-radius: 100px;
    background-color: var(--logo-green);
}

/* Hide progress text for previous steps on mobile, but keep current step visible */
@media (max-width: 767px) {
    .progress_text.reached:not(.current) {
        display: none;
    }
}

.email-error {
    border: 2px solid #e53e3e !important;
    background-color: #fff5f5 !important;
}

.error-message {
    color: #e53e3e;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
}

.error-message.step-error {
    text-align: center;
    margin-top: 14px;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
}

.paid-user-modal {
    position: relative;
    background: #fff;
    border-radius: 16px;
    padding: 40px 32px 32px;
    max-width: 420px;
    width: 90%;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
    text-align: center;
}

.modal-title {
    font-size: 24px;
    font-weight: 700;
    margin: 0 0 16px;
    color: #1a1a1a;
    text-align: center;
}

.modal-close {
    position: absolute;
    top: 16px;
    right: 16px;
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #666;
    padding: 4px 8px;
    line-height: 1;
}

.modal-body p {
    font-size: 15px;
    line-height: 1.5;
    color: #555;
    margin: 0 0 24px;
    text-align: center;
}

.modal-btn {
    display: block;
    width: 100%;
    padding: 14px 22px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    margin-bottom: 10px;
}

.modal-btn-primary {
    background: #42cad1;
    color: #fff;
}

.modal-btn-secondary {
    background: #fff;
    color: #1a1a1a;
    border: 1px solid #e0e0e0;
    font-weight: 500;
}

.sms-disclaimer {
    color: #6c7e8d;
    font-size: 11px;
    line-height: 15px;
    margin-top: 8px;
    margin-bottom: 16px;
}
.sms-disclaimer a {
    color: #6c7e8d;
    text-decoration: underline;
}

.sms-consent-checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 12px;
    margin-bottom: 8px;
    padding: 0;
    cursor: pointer;
}
.sms-consent-checkbox .w-checkbox-input {
    margin-top: 3px;
    flex-shrink: 0;
}
.sms-consent-label {
    color: #6c7e8d;
    font-size: 11px;
    line-height: 15px;
    display: inline-block;
}
.sms-consent-checkbox.field-error .sms-consent-label {
    color: #e53e3e;
}

@keyframes consent-shake {
    0%, 100% { transform: translateX(0); }
    20% { transform: translateX(-8px); }
    40% { transform: translateX(8px); }
    60% { transform: translateX(-8px); }
    80% { transform: translateX(8px); }
}
.is-shaking {
    animation: consent-shake 0.5s ease-in-out;
}

.error-message {
    color: #e53e3e;
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 10px;
}
</style>
